import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    container: props => ({
        '& > div':{
            [`& > div:nth-child(${props.position})`]: {
                zIndex: 1,
            }
        }
    }),
    containerHeader: {
        '& > div': {
            backgroundColor: 'rgba(290,257, 248, 0.6)',
        }
    },
    rootProgressBar: {
        background: '#FFFFFF',
        opacity: '0.6',
    },
    rootLine: {
        border: '1px dashed #3A43BA',
        width: '0px',
        height: '14px',
    },
    rootLineMissed: {
        border: '1px dashed white',
    },
}), {
    name: 'ProgressBarSurveyHeadContainer',
    index: 1,
})

export default useStyles